import { Global, Lock } from 'iconsax-react';
import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';

export function PublicOrPrivateDropdown({
  onChange,
  value,
}: {
  value: boolean;
  onChange: (val: boolean) => void;
}) {
  const options = [
    {
      label: 'Private',
      value: false,
      icon: (
        <Lock
          variant='Bold'
          size={16}
        />
      ),
      className: 'text-gray-900 bg-primary-50 hover:bg-primary-50',
    },
    {
      label: 'Public',
      value: true,
      icon: <Global size={16} />,
      className: 'text-blue-600 bg-blue-50 hover:bg-blue-50',
    },
  ];

  const currentValue = options.find((opt) => opt.value === value);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'cursor-pointer text-gray-900 hover:bg-primary-100/60 flex gap-2 items-center p-2 bg-primary-50 rounded-xl text-sm',
          currentValue?.className
        )}
      >
        {currentValue?.icon} {currentValue?.label} <ChevronDown size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        {options.map((opt) => (
          <DropdownMenuItem
            className={cn(opt.label === currentValue?.label && opt.className)}
            onClick={() => onChange(opt.value)}
            key={opt.value.toString()}
          >
            {opt.icon} {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
